import { ROOT_FOLDER } from './folders/root-folder';
import * as i0 from "@angular/core";
var DriveUrlsService = /** @class */ (function () {
    function DriveUrlsService() {
    }
    DriveUrlsService.prototype.driveRoot = function () {
        return '/drive';
    };
    DriveUrlsService.prototype.folder = function (folder) {
        if (folder === ROOT_FOLDER) {
            return this.driveRoot();
        }
        else {
            return "/drive/folders/" + folder.hash;
        }
    };
    DriveUrlsService.ngInjectableDef = i0.defineInjectable({ factory: function DriveUrlsService_Factory() { return new DriveUrlsService(); }, token: DriveUrlsService, providedIn: "root" });
    return DriveUrlsService;
}());
export { DriveUrlsService };
